import './TextLink.scss'

import React, { useCallback } from 'react'

import Icon from '../Icon/Icon'
import classNames from 'classnames'
import { withRouter } from 'react-router-dom'

const DEFAULT_ICON_SIZE = 20

const ICON_SIZES = {
  "small": 16,
  "field-sized": 20,
  "default": 20,
  "medium": 20,
  "large": 24
}

const SIZE_CLASSES = {
  "small": "label-small-basic",
  "field-sized": "label-field-sized-basic",
  "default": "label-default-basic",
  "medium": "label-medium-basic",
  "large": "label-large-basic"
}

const TextLink = withRouter(({ label, labelOrientation, size, icon, link, onClick, history }) => {
  const left = labelOrientation === 'left'

  const handleClick = useCallback(event => {
    if (link) history.push(link)
    else if (onClick) onClick(event)
  }, [link, onClick, history])

  return (
    <div className={classNames("text-link", { "-right": !left, "-left": left })} onClick={handleClick}>
      <Icon size={ICON_SIZES[size] || DEFAULT_ICON_SIZE} icon={icon}></Icon>
      <div
        className={classNames("-label", "-size-" + size, SIZE_CLASSES[size] || SIZE_CLASSES[DEFAULT_ICON_SIZE])}
      >
        {label}
      </div>
    </div>
  )
})

export default TextLink